__turbopack_context__.v({
  "amount": "styles-module__RDnvma__amount",
  "base": "styles-module__RDnvma__base",
  "currency": "styles-module__RDnvma__currency",
  "entityWrap": "styles-module__RDnvma__entityWrap",
  "small": "styles-module__RDnvma__small",
  "typeCount": "styles-module__RDnvma__typeCount",
});
